import memoize from 'memoize-one';
import { LoadingStoreState } from '../../data/models/loading-store-state';
export const getGroupId = memoize((state) => state.get('groupStore').get('groupId'));
export const getGroupName = memoize((state) => state.get('groupStore').get('groupName'));
export const getGroups = memoize((state) => state.get('groupStore').get('groups'));
export const shouldFilterLabsByGroupId = memoize((state) => state.get('groupStore').get('shouldFilterByGroupId'));
export const isLoadingGroupName = memoize((state) => state.get('groupStore').get('loadState') === LoadingStoreState.Loading);
export const isLoadingGroupList = memoize((state) => state.get('groupStore').get('groupsLoadState') === LoadingStoreState.Loading);
